import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BlogPostPreviewCard from '../blogPostPreviewCard/BlogPostPreviewCard';

export const getCategoryName = (category) => {
  return category.replace(/\s/g, '-').toLowerCase();
};

const BlogPostGrid = ({ blogPosts, gridStyle, loadMoreTarget, showDescription = false }) => {
  const componentClasses = classNames('blog-posts-grid', {
    'js-blog-grid': gridStyle === undefined || loadMoreTarget !== undefined,
    'js-blog-posts': gridStyle === 'search',
    [`${gridStyle}-blog-post-wrapper`]: gridStyle !== undefined
  });

  return (
    <article className={componentClasses}>
      {blogPosts.map((post) => (
        <BlogPostPreviewCard
          key={post.slug}
          blogPost={post}
          showCategory={gridStyle !== 'blog-grid-categories' ? true : false}
          showMedia={gridStyle !== 'tertiary' ? true : false}
          showDescription={showDescription ? true : gridStyle === 'primary' ? true : false}
          className={`blog-post-preview-card ${gridStyle !== undefined ? `${gridStyle}-blog-post` : ``}`}
        />
      ))}
    </article>
  );
};

BlogPostGrid.propTypes = {
  blogPosts: PropTypes.arrayOf(PropTypes.object),
  gridStyle: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'search', 'blog-grid-categories']),
  loadMoreTarget: PropTypes.string,
  showDescription: PropTypes.bool
};

export default BlogPostGrid;
